import { useGetQaSpecRequiredFieldsInQaSpecFullView } from 'pages/qa-spec/hooks/useGetQaSpecRequiredFields';

export const useFactPanelQasRequiredFields = ({
  productId,
  typeView,
  section,
}) => {
  const { data: requiredFields } = useGetQaSpecRequiredFieldsInQaSpecFullView({
    productId: typeView === 'qa-spec' && productId,
  });

  const checkQasRequiredField = (fieldName) => {
    if (!requiredFields?.length) return false;

    const isNormalRequired = requiredFields.includes(
      `${section}.${fieldName}`.toLowerCase()
    );

    return isNormalRequired;
  };

  const getRequiredRule = ({ fieldName = [], displayName }) => {
    const isQasRequiredField = checkQasRequiredField(fieldName.join('.'));

    return {
      required: isQasRequiredField,
      message: `${displayName || 'This field'} is required`,
    };
  };

  return { getRequiredRule };
};
